/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import ReactTable from "react-table-v6";
import Pagination from "../Beneficios/Pagination.js";
import sendLogError from "../../sendLogError";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* CSS IMPORT */
import "./Notifications.css";
import { Loading } from "../../components/Loading/Loading";
import notificationreadImg from "../../images/notificationread.svg";
import notificationnotreadImg from "../../images/notificationnotread.svg";
import expand180Img from "../../images/expand180.png";
import expandImg from "../../images/expand.png";
import emailImg from "../../images/email.png";

export class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      notificationsList: [],
      height: 0,
      width: 0,
      expanded: 0,
      open: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateData();
      this.updateWindowDimensions();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  expandRow(id) {
    this.setState({
      expanded: id == this.state.expanded ? 0 : id,
    });
  }

  renderMailListTable(notificationsList) {
    const columns =
      this.state.width <= 880
        ? [
            {
              Header: "",
              accessor: "isRead",
              minWidth: 30,
              maxWidth: 60,
              Cell: (row) => (
                <img
                  alt=""
                  src={row.value ? notificationreadImg : notificationnotreadImg}
                />
              ),
            },
            {
              id: "date",
              Header: "",
              Cell: ({ original }) => (
                <div>
                  <div className={original.isRead ? "mail-date read-notification" : "mail-date"}>
                    {new Intl.DateTimeFormat("pt-PT").format(new Date(original.date))}
                  </div>
                  <div className="mail-name">
                    <div className="notification-topic">
                      {original.topic}
                      {/*<span className="notification-description">{" - " + original.description}</span>*/}
                    </div>
                  </div>
                  <div
                    className={
                      this.state.expanded === original.id
                        ? "notification-description-under notification-expanded"
                        : "notification-description-under"
                    }>
                    {original.description}
                  </div>
                </div>
              ),
            },
            {
              Header: "",
              accessor: "id",
              minWidth: 30,
              maxWidth: 60,
              Cell: ({ original }) => (
                <div>
                  <img
                    style={{ width: "14px", cursor: "pointer" }}
                    onClick={() => {
                      this.expandRow(original.id);
                    }}
                    src={this.state.expanded == original.id ? expand180Img : expandImg}
                    alt="expandir"
                  />
                </div>
              ),
            },
          ]
        : [
            {
              id: "isRead",
              Header: "",
              accessor: "isRead",
              minWidth: 30,
              maxWidth: 60,
              Cell: (row) => (
                <img
                  alt=""
                  src={row.value ? notificationreadImg : notificationnotreadImg}
                />
              ),
            },
            {
              id: "date",
              Header: "",
              minWidth: 60,
              maxWidth: 90,
              className: "mail-date-wrapper",
              Cell: ({ original }) => (
                <div className="mail-date">
                  {new Intl.DateTimeFormat("pt-PT").format(new Date(original.date))}
                </div>
              ),
            },
            {
              Header: "",
              Cell: ({ original }) => (
                <div>
                  <div className="mail-name">
                    <div className="notification-topic">
                      {original.topic}
                      {/*<span className="notification-description">{" - " + original.description}</span>*/}
                    </div>
                  </div>
                  <div
                    className={
                      this.state.expanded === original.id
                        ? "notification-description-under notification-expanded"
                        : "notification-description-under"
                    }>
                    {original.description}
                  </div>
                </div>
              ),
            },
            {
              Header: "",
              accessor: "id",
              minWidth: 30,
              maxWidth: 60,
              Cell: ({ original }) => (
                <div>
                  <img
                    style={{ width: "14px", cursor: "pointer" }}
                    onClick={() => {
                      this.expandRow(original.id);
                    }}
                    src={this.state.expanded == original.id ? expand180Img : expandImg}
                    alt="expandir"
                  />
                </div>
              ),
            },
          ];

    return (
      <ReactTable
        data={notificationsList}
        columns={columns}
        resizable={false}
        nextText=">"
        previousText="<"
        sortable={false}
        minRows="0"
        PaginationComponent={Pagination}
        defaultPageSize={notificationsList.length <= 6 ? notificationsList.length : 6}
        getTrProps={(state, rowInfo) => {
          return {
            onClick: (e) => {
              if (rowInfo.original.isRead !== true) {
                //a resquest to the server is required to mark this mail as read
                this.markNotificationAsRead(rowInfo, state);
              }
            },
            style: {
              padding: "12px 27px 12px 31px",
              background: rowInfo
                ? rowInfo.row.isRead
                  ? "rgba(255,255,255,0.3)"
                  : "white"
                : "white",
              color: rowInfo ? (rowInfo.row.isRead ? "#6D6E71" : "#373737") : "#373737",
              cursor: "pointer",
              alignItems: this.state.expanded == rowInfo.row.id ? "end" : "center",
            },
          };
        }}
      />
    );
  }

  updateTableReadState(rowInfo, state) {
    //the current value will be updated without refresh
    state.data[rowInfo.index].isRead = true;

    this.setState({
      data: state.data,
      loading: false,
    });
  }

  renderListagemCorreio(notificationsList) {
    return (
      <main className="main">
        <div className="title-bar title-bar-mail">
          <div className="title">Notificações</div>
        </div>
        <div className="notifications-list-wrapper">
          <div className="mail-list">{this.renderMailListTable(notificationsList)}</div>
        </div>
      </main>
    );
  }

  renderListagemCorreioVazia() {
    return (
      <main className="main">
        <div className="no-mail-div">
          <img className="no-mail-img" alt="" src={emailImg}></img>
          <div className="no-mail-text">Não recebeu nenhuma notificação.</div>
        </div>
      </main>
    );
  }

  render() {
    let contents = "";

    if (this.state.loading) {
      contents = <Loading />;
    } else if (this.state.error) {
      contents = <ErrorPage />;
    } else if (this.state.notificationsList.length) {
      contents = this.renderListagemCorreio(this.state.notificationsList);
    } else {
      contents = this.renderListagemCorreioVazia();
    }

    return <div>{contents}</div>;
  }

  async populateData() {
    try {
        const { selectedUserID, idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
            clientId: selectedUserID,
        };

        const response = await fetch(
            `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
            { headers }
        );

        if (!response.ok) {
          this.setState({loading: false, error: false});
          return;
        }

        const data = await response.json();

        const notifications = Array.isArray(data) ? data : [];

        // ordenação:
        const sorted = notifications.sort((a, b) => {
            if (a.isRead !== b.isRead) {
                return a.isRead ? 1 : -1; // não lidos primeiro
            }

            return new Date(b.date) - new Date(a.date); // mais recentes primeiro
        });

        this.setState({
            notificationsList: sorted,
            error: false,
            loading: false,
        });
    } catch (err) {
        console.error("Error fetching notifications:", err);

        this.setState({
            error: true,
            loading: false,
        });

        sendLogError(err.message, "populateData");
    }
  }

  async markNotificationAsRead(rowInfo, state) {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
            "Content-Type": "application/json",
        };

        const id = rowInfo.original.id;

        // 1️⃣ marcar como lido
        const resMark = await fetch(
            `/Notifications/MarkNotificationAsRead?Id=${id}`,
            {
                method: "POST",
                headers,
            }
        );

        if (!resMark.ok) {
            throw new Error(`Erro MarkNotification: ${resMark.status}`);
        }

        const result = await resMark.json();

        // 2️⃣ dismiss notificação (não crítico)
        const resDismiss = await fetch(
            `/Notifications/DismissTopNotification?Id=${id}`,
            {
                method: "POST",
                headers,
            }
        );

        if (!resDismiss.ok) {
            console.warn("Dismiss failed:", resDismiss.status);
        }

        // 3️⃣ atualizar UI
        if (result === true) {
            this.updateTableReadState(rowInfo, state);
        }

    } catch (err) {
        console.error("Error marking notification as read:", err);

        sendLogError(err.message, "markNotificationAsRead");
    }
  }
}

Notifications.contextType = ContextConstructor;

export default Notifications;
